/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */

export type SearchImagesProvider =
  (typeof SearchImagesProvider)[keyof typeof SearchImagesProvider];

export const SearchImagesProvider = {
  naver: 'naver',
  pexels: 'pexels',
} as const;
